import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-agent-counter-settings',
    templateUrl: './agent-counter-settings.component.html',
    styleUrls: ['./agent-counter-settings.component.scss']
})
export class AgentCounterSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;

    constructor(
        public navigationService: NavigationService,
    ) { }

    ngOnInit(): void {
    }

}
